import { BASE_URL } from '@/config/serverApiConfig';

export function getFullName(person) {
    if (!person) return '';
    const parts = [person.name, person.surname].filter(Boolean);
    return parts.join(' ').trim() || person.name || person.email || '';
}

export function getInitials(personOrName = '') {
    const name = typeof personOrName === 'string' ? personOrName : getFullName(personOrName);
    return name.split(' ').filter(Boolean).map((part) => part[0]).join('').toUpperCase().slice(0, 2) || '?';
}

export function getPhotoUrl(photo) {
    if (!photo) return null;
    if (/^https?:\/\//i.test(photo)) return photo;
    const relative = photo.startsWith('/') ? photo : `/public/uploads/admin/${photo}`;
    const base = (BASE_URL || '').replace(/\/$/, '');
    return `${base}${relative}`;
}
